import styled, { css } from 'styled-components/macro';
import { checkRounded } from 'ui/scss/app.scss';

export const NoItems = styled.div`
    .no-items {
        padding-top: 20px;
    }
`;

export const PostContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 150px;
    margin-bottom: 10px;

    @media ${props => props.theme.device.laptop} {
        padding: 0;
    }

    .remove-feed {
        padding-top: 20px;
    }

    .remove-comment {
        padding-left: 8px;
        width: 100%;
    }

    .d-none {
        display: none !important;
    }
`;

export const BtnContainer = styled.div`
  button {
    font-weight: 600;
  }

  &.show-posts {
    //display: none;
    margin-top: 100px;
    margin-bottom: 100px;
  }

  button {
    background: transparent;
    color: #33a7b2;
    padding: 0;
    margin: 0 auto;

    &:hover {
      background-color: transparent ;
    }
  }
`;

export const Icon = styled.div`
  font-size: x-large;
  text-align: right;
  cursor: pointer;
`;

export const IconEdit = styled(Icon)`
  color: ${props => props.theme.colors.moonstone};
`;

export const IconDelete = styled.div`
  font-size: 25px;
  color: ${props => props.theme.colors.moonstone};
  cursor: pointer;
  padding-left: 5px;
`;

export const PostContainerHead = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 0 30px;
    margin-top: 65px;
    margin-bottom: 25px;

    @media ${props => props.theme.device.tablet} {
        padding: 0;
    }

    .avatar {
        border-radius: 100%;
        width: 60px;
        min-width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props => props.theme.colors.bitterLemon};
        color: white;

        @media ${props => props.theme.device.mobile} {
            width: 50px;
            min-width: 50px;
            height: 50px;
        }

        .initials {
            @media ${props => props.theme.device.mobile} {
                font-size: 20px;
            }   
        }
    }

    .head-text-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding-left: 45px;

        @media ${props => props.theme.device.tablet} {
            padding-left: 25px;
        }

        @media ${props => props.theme.device.mobile} {
            padding-left: 15px;
        }

        .head-description {
            display: flex;
            flex-direction: row;

            @media ${props => props.theme.device.mobile} {
                flex-direction: column;
            }

            .name {
                @media ${props => props.theme.device.mobile} {
                    margin-bottom: 5px;
                }
            }

            .description {
                margin-left: 8px;
                color: ${props => props.theme.colors.lightGrey};

                @media ${props => props.theme.device.mobile} {
                    margin-left: 0;
                    margin-bottom: 5px;
                }
            }
        }

        .head-comment {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            margin-top: 4px;
            flex-wrap: wrap;

            .comment, .comment-time {
                margin-bottom: 5px;
            }

            .comment-time-wrapper {
                margin-left: auto;
            }

            .icon-icona-elimina {
                padding-left: 20px;
            }
        }
    }
`;

export const CardContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;

    @media ${props => props.theme.device.mobile} {
        flex-direction: column;
    }
`;

export const ShowMoreComments = styled.div`

`;

export const CommentCard = styled.div`
    background-color: ${props => props.theme.colors.commentCardGrey};
    border-radius: 0px 30px 30px 0px;
    padding: 28px 56px;
    width: 100%;
    min-height: 363px;

    @media ${props => props.theme.device.tablet} {
        padding: 26px;
    }

    @media ${props => props.theme.device.mobile} {
        border-radius: 0px 0px 30px 30px;
        padding: 16px;
    }

    .card-title {
        margin-bottom: 15px;
        line-height: 1.3;
        color: ${props => props.theme.colors.moonstone};
    }

    .card-subtitle {
        margin-bottom: 45px;
        line-height: 1.3;
    }
`;

export const ImageCard = styled.div`
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: ${props => props.bg
            ? `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 96.81%), url(${props.bg})`
            : `linear-gradient(45deg, ${props.theme.colors.primary.base} 0%, ${props.theme.colors.ghostWhite} 100%)`
        };
    width: 100%;
    border-radius: 30px 0px 0px 30px;
    max-width: 287px;
    margin-right: 27px;
    filter: drop-shadow(3px 4px 16px rgba(0, 0, 0, 0.25));
    max-height: 363px;
    min-height: 363px;

    @media ${props => props.theme.device.desktop} {
        max-width: 250px;
    }

    @media ${props => props.theme.device.tablet} {
        max-width: 215px;
    }

    @media ${props => props.theme.device.mobile} {
        height: 100%;
        max-height: 215px;
        min-height: 215px;
        min-width: 100%;
        margin-right: 0;
        margin-bottom: 18px;
        border-radius: 30px 30px 0px 0px;
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    flex-wrap: wrap;
    .actions {
        display: flex;
        flex-direction: row;
        align-items: center;

        @media ${props => props.theme.device.tablet} {
            margin-bottom: 15px
        }

        .action-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 12px;

            .circle {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 34px;
                min-width: 34px;
                height: 35px;
                background-color: white;
                border-radius: 100%;
                margin-right: 12px;
                cursor: pointer;

                .image-wrapper {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                &.like {
                    .image {
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='15' viewBox='0 0 16 15' fill='none'%3E%3Cpath d='M13.3333 15H8.8654C8.23446 15.0003 7.60775 14.8984 7.01024 14.6984L5.17829 14.0866C5.04935 14.3579 4.84526 14.5876 4.5896 14.7492C4.33394 14.9109 4.03714 14.9978 3.73352 15H0.533597C0.391085 14.9987 0.25489 14.9418 0.154868 14.8416C0.0548456 14.7414 -0.000843048 14.6062 9.64987e-06 14.4655V4.84579C-0.000843048 4.70515 0.0548456 4.56991 0.154868 4.46972C0.25489 4.36953 0.391085 4.31257 0.533597 4.31132H3.73352C4.05674 4.31159 4.37221 4.40894 4.638 4.59044C4.90379 4.77193 5.10731 5.02897 5.22149 5.32737C6.60225 4.98947 7.87342 3.11684 8.26141 1.56947L8.54941 0.405C8.57733 0.290079 8.6435 0.18772 8.73733 0.114297C8.83117 0.0408737 8.94724 0.000628822 9.06699 0L9.59978 0C10.1698 0.00500545 10.7145 0.232885 11.1144 0.633662C11.5144 1.03444 11.737 1.5754 11.7333 2.13789V2.67158C11.707 3.58943 11.5597 4.49999 11.2949 5.38026H14.3997C14.827 5.38402 15.2354 5.55482 15.5353 5.85524C15.8352 6.15566 16.0022 6.56118 15.9996 6.9829C15.9999 7.37632 15.8548 7.75634 15.5916 8.05184C15.8547 8.34744 15.9997 8.7274 15.9997 9.12079C15.9997 9.51418 15.8547 9.89414 15.5916 10.1897C15.7737 10.3935 15.9006 10.6394 15.9607 10.9046C16.0207 11.1698 16.0119 11.4456 15.935 11.7065C15.8582 11.9674 15.7158 12.2049 15.5211 12.397C15.3264 12.5891 15.0857 12.7295 14.8213 12.8053C14.8956 12.9938 14.9335 13.1943 14.9333 13.3966C14.936 13.8184 14.7691 14.2242 14.4692 14.5247C14.1693 14.8253 13.7608 14.9962 13.3333 15ZM9.48298 1.06895L9.29339 1.82921C8.99975 2.93312 8.46546 3.96045 7.72783 4.83947C7.13249 5.61224 6.2874 6.16099 5.33268 6.39474V13.0082L7.34624 13.68C7.83576 13.844 8.34925 13.9274 8.8662 13.9271H13.3341C13.4778 13.9271 13.6157 13.8708 13.7173 13.7704C13.819 13.6701 13.8761 13.5341 13.8761 13.3922C13.8761 13.2504 13.819 13.1143 13.7173 13.014C13.6157 12.9137 13.4778 12.8574 13.3341 12.8574C13.1905 12.8574 13.0527 12.8011 12.9511 12.7008C12.8496 12.6006 12.7925 12.4646 12.7925 12.3229C12.7925 12.1811 12.8496 12.0452 12.9511 11.945C13.0527 11.8447 13.1905 11.7884 13.3341 11.7884H14.3997C14.5433 11.7884 14.6811 11.7321 14.7826 11.6319C14.8842 11.5316 14.9413 11.3957 14.9413 11.2539C14.9413 11.1122 14.8842 10.9763 14.7826 10.876C14.6811 10.7758 14.5433 10.7195 14.3997 10.7195H13.3333C13.1897 10.7195 13.0519 10.6632 12.9503 10.5629C12.8488 10.4627 12.7917 10.3268 12.7917 10.185C12.7917 10.0432 12.8488 9.9073 12.9503 9.80707C13.0519 9.70684 13.1897 9.65053 13.3333 9.65053H14.3997C14.5433 9.65053 14.6811 9.59422 14.7826 9.49398C14.8842 9.39375 14.9413 9.2578 14.9413 9.11605C14.9413 8.9743 14.8842 8.83836 14.7826 8.73812C14.6811 8.63789 14.5433 8.58158 14.3997 8.58158H13.3333C13.1897 8.58158 13.0519 8.52527 12.9503 8.42504C12.8488 8.3248 12.7917 8.18886 12.7917 8.04711C12.7917 7.90535 12.8488 7.76941 12.9503 7.66918C13.0519 7.56894 13.1897 7.51263 13.3333 7.51263H14.3997C14.5433 7.51263 14.6811 7.45632 14.7826 7.35609C14.8842 7.25585 14.9413 7.11991 14.9413 6.97816C14.9413 6.83641 14.8842 6.70046 14.7826 6.60023C14.6811 6.49999 14.5433 6.44368 14.3997 6.44368H9.06699C8.92336 6.44368 8.7856 6.38737 8.68403 6.28714C8.58247 6.18691 8.52541 6.05096 8.52541 5.90921C8.52541 5.76746 8.58247 5.63151 8.68403 5.53128C8.7856 5.43105 8.92336 5.37474 9.06699 5.37474H10.1598C10.4768 4.50491 10.6491 3.5902 10.6702 2.66605V2.13789C10.671 1.99835 10.644 1.86 10.5906 1.73076C10.5373 1.60152 10.4587 1.48391 10.3593 1.38465C10.2599 1.28538 10.1417 1.20642 10.0114 1.15225C9.88104 1.09808 9.74119 1.06977 9.59978 1.06895H9.48298ZM1.06638 5.38026V13.9311H3.73352C3.87603 13.9298 4.01223 13.8728 4.11225 13.7727C4.21227 13.6725 4.26796 13.5372 4.26711 13.3966V5.91474C4.26796 5.77409 4.21227 5.63886 4.11225 5.53867C4.01223 5.43848 3.87603 5.38151 3.73352 5.38026H1.06638Z' fill='%2333A7B2'/%3E%3C/svg%3E");
                        background-repeat: no-repeat;
                        width: 16px;
                        height: 16px;
                    }
                }

                &.liked {
                    background-color: ${props => props.theme.colors.moonstone};
                    .image {
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='15' viewBox='0 0 16 15' fill='none '%3E%3Cpath d='M13.3333 15H8.8654C8.23446 15.0003 7.60775 14.8984 7.01024 14.6984L5.17829 14.0866C5.04935 14.3579 4.84526 14.5876 4.5896 14.7492C4.33394 14.9109 4.03714 14.9978 3.73352 15H0.533597C0.391085 14.9987 0.25489 14.9418 0.154868 14.8416C0.0548456 14.7414 -0.000843048 14.6062 9.64987e-06 14.4655V4.84579C-0.000843048 4.70515 0.0548456 4.56991 0.154868 4.46972C0.25489 4.36953 0.391085 4.31257 0.533597 4.31132H3.73352C4.05674 4.31159 4.37221 4.40894 4.638 4.59044C4.90379 4.77193 5.10731 5.02897 5.22149 5.32737C6.60225 4.98947 7.87342 3.11684 8.26141 1.56947L8.54941 0.405C8.57733 0.290079 8.6435 0.18772 8.73733 0.114297C8.83117 0.0408737 8.94724 0.000628822 9.06699 0L9.59978 0C10.1698 0.00500545 10.7145 0.232885 11.1144 0.633662C11.5144 1.03444 11.737 1.5754 11.7333 2.13789V2.67158C11.707 3.58943 11.5597 4.49999 11.2949 5.38026H14.3997C14.827 5.38402 15.2354 5.55482 15.5353 5.85524C15.8352 6.15566 16.0022 6.56118 15.9996 6.9829C15.9999 7.37632 15.8548 7.75634 15.5916 8.05184C15.8547 8.34744 15.9997 8.7274 15.9997 9.12079C15.9997 9.51418 15.8547 9.89414 15.5916 10.1897C15.7737 10.3935 15.9006 10.6394 15.9607 10.9046C16.0207 11.1698 16.0119 11.4456 15.935 11.7065C15.8582 11.9674 15.7158 12.2049 15.5211 12.397C15.3264 12.5891 15.0857 12.7295 14.8213 12.8053C14.8956 12.9938 14.9335 13.1943 14.9333 13.3966C14.936 13.8184 14.7691 14.2242 14.4692 14.5247C14.1693 14.8253 13.7608 14.9962 13.3333 15ZM9.48298 1.06895L9.29339 1.82921C8.99975 2.93312 8.46546 3.96045 7.72783 4.83947C7.13249 5.61224 6.2874 6.16099 5.33268 6.39474V13.0082L7.34624 13.68C7.83576 13.844 8.34925 13.9274 8.8662 13.9271H13.3341C13.4778 13.9271 13.6157 13.8708 13.7173 13.7704C13.819 13.6701 13.8761 13.5341 13.8761 13.3922C13.8761 13.2504 13.819 13.1143 13.7173 13.014C13.6157 12.9137 13.4778 12.8574 13.3341 12.8574C13.1905 12.8574 13.0527 12.8011 12.9511 12.7008C12.8496 12.6006 12.7925 12.4646 12.7925 12.3229C12.7925 12.1811 12.8496 12.0452 12.9511 11.945C13.0527 11.8447 13.1905 11.7884 13.3341 11.7884H14.3997C14.5433 11.7884 14.6811 11.7321 14.7826 11.6319C14.8842 11.5316 14.9413 11.3957 14.9413 11.2539C14.9413 11.1122 14.8842 10.9763 14.7826 10.876C14.6811 10.7758 14.5433 10.7195 14.3997 10.7195H13.3333C13.1897 10.7195 13.0519 10.6632 12.9503 10.5629C12.8488 10.4627 12.7917 10.3268 12.7917 10.185C12.7917 10.0432 12.8488 9.9073 12.9503 9.80707C13.0519 9.70684 13.1897 9.65053 13.3333 9.65053H14.3997C14.5433 9.65053 14.6811 9.59422 14.7826 9.49398C14.8842 9.39375 14.9413 9.2578 14.9413 9.11605C14.9413 8.9743 14.8842 8.83836 14.7826 8.73812C14.6811 8.63789 14.5433 8.58158 14.3997 8.58158H13.3333C13.1897 8.58158 13.0519 8.52527 12.9503 8.42504C12.8488 8.3248 12.7917 8.18886 12.7917 8.04711C12.7917 7.90535 12.8488 7.76941 12.9503 7.66918C13.0519 7.56894 13.1897 7.51263 13.3333 7.51263H14.3997C14.5433 7.51263 14.6811 7.45632 14.7826 7.35609C14.8842 7.25585 14.9413 7.11991 14.9413 6.97816C14.9413 6.83641 14.8842 6.70046 14.7826 6.60023C14.6811 6.49999 14.5433 6.44368 14.3997 6.44368H9.06699C8.92336 6.44368 8.7856 6.38737 8.68403 6.28714C8.58247 6.18691 8.52541 6.05096 8.52541 5.90921C8.52541 5.76746 8.58247 5.63151 8.68403 5.53128C8.7856 5.43105 8.92336 5.37474 9.06699 5.37474H10.1598C10.4768 4.50491 10.6491 3.5902 10.6702 2.66605V2.13789C10.671 1.99835 10.644 1.86 10.5906 1.73076C10.5373 1.60152 10.4587 1.48391 10.3593 1.38465C10.2599 1.28538 10.1417 1.20642 10.0114 1.15225C9.88104 1.09808 9.74119 1.06977 9.59978 1.06895H9.48298ZM1.06638 5.38026V13.9311H3.73352C3.87603 13.9298 4.01223 13.8728 4.11225 13.7727C4.21227 13.6725 4.26796 13.5372 4.26711 13.3966V5.91474C4.26796 5.77409 4.21227 5.63886 4.11225 5.53867C4.01223 5.43848 3.87603 5.38151 3.73352 5.38026H1.06638Z' stroke='white' fill='none'/%3E%3C/svg%3E");
                    }
                }

                &.comment {
                    .image {
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'%3E%3Cpath d='M7.00011 1C3.68637 1 1 3.68637 1 7.00011C1 8.09345 1.29255 9.11868 1.80342 10.0014L1 13L3.99863 12.1966C4.88132 12.7077 5.90655 13 6.99989 13C10.3136 13 13 10.3136 13 6.99989C13 3.68616 10.3138 1 7.00011 1ZM10.8068 10.8065C10.3123 11.3012 9.73641 11.6892 9.09547 11.9603C8.4322 12.241 7.72732 12.3832 7.00033 12.3832C6.51924 12.3832 6.0421 12.3199 5.58269 12.1946C5.1373 12.0735 4.70855 11.8944 4.30782 11.6625L4.08644 11.5344L3.83922 11.6008L1.87239 12.1276L2.39946 10.161L2.46581 9.91378L2.33749 9.69218C2.10582 9.29167 1.9267 8.86292 1.80561 8.41753C1.68057 7.95812 1.61707 7.48098 1.61707 6.99989C1.61707 6.2729 1.7594 5.56802 2.03991 4.90475C2.311 4.26381 2.69924 3.68791 3.1939 3.19324C3.68835 2.6988 4.26425 2.31056 4.90518 2.03947C5.56846 1.75896 6.27333 1.61663 7.00033 1.61663C7.72732 1.61663 8.43242 1.75896 9.09547 2.03947C9.73641 2.31056 10.3123 2.6988 10.8068 3.19324C11.3014 3.68791 11.6897 4.26359 11.9607 4.90475C12.2413 5.56802 12.3834 6.2729 12.3834 6.99989C12.3834 7.72688 12.2413 8.43198 11.9607 9.09503C11.6897 9.73597 11.3014 10.3121 10.8068 10.8065Z' stroke='%2333A7B2' stroke-width='0.7'/%3E%3C/svg%3E");
                        background-repeat: no-repeat;
                        width: 14px;
                        height: 14px;
                    }
                }
            }
        }
    }

    .actions-details {
        display: flex;
        align-items: center;

        @media ${props => props.theme.device.tablet} {
            margin-bottom: 15px
        }

        .comments-shares {
            display: flex;
            flex-direction: row;

            .comments {
                margin-right: 7px;
                //cursor: pointer;
            }

            .shares {
                margin-right: 12px;
            }
        }

        .likes {
            display: flex;
            flex-direction: row;

            .like, .dislike {
                display: flex;
                align-items: center;
                color: ${props => props.theme.colors.moonstone};

                .image {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='13' viewBox='0 0 13 13' fill='none'%3E%3Cpath d='M10.7605 12.6847H7.15475C6.64556 12.685 6.13978 12.6016 5.65756 12.4381L4.1791 11.9377C4.07504 12.1596 3.91033 12.3475 3.704 12.4797C3.49767 12.6118 3.25814 12.6829 3.01311 12.6847H0.430635C0.315622 12.6837 0.205707 12.6371 0.124985 12.5552C0.0442628 12.4733 -0.000680376 12.3627 7.78785e-06 12.2476V4.38078C-0.000680376 4.26576 0.0442628 4.15516 0.124985 4.07323C0.205707 3.9913 0.315622 3.94472 0.430635 3.94369H3.01311C3.27396 3.94391 3.52856 4.02353 3.74306 4.17195C3.95757 4.32037 4.12181 4.53057 4.21396 4.7746C5.3283 4.49828 6.35419 2.96687 6.66731 1.70146L6.89973 0.749171C6.92227 0.655191 6.97567 0.571483 7.0514 0.511439C7.12713 0.451395 7.22081 0.418483 7.31745 0.417969H7.74743C8.20742 0.422062 8.64702 0.608418 8.9698 0.936167C9.29259 1.26392 9.47222 1.7063 9.4693 2.1663V2.60274C9.44807 3.35335 9.32913 4.09799 9.1155 4.81786H11.6211C11.966 4.82093 12.2956 4.96061 12.5376 5.20629C12.7797 5.45197 12.9144 5.78359 12.9124 6.12847C12.9126 6.4502 12.7955 6.76098 12.5831 7.00263C12.7954 7.24437 12.9125 7.55509 12.9125 7.8768C12.9125 8.19851 12.7954 8.50923 12.5831 8.75097C12.73 8.91764 12.8325 9.11873 12.8809 9.33558C12.9294 9.55242 12.9223 9.77799 12.8603 9.99135C12.7982 10.2047 12.6833 10.3989 12.5262 10.556C12.369 10.7131 12.1748 10.828 11.9614 10.8899C12.0213 11.0441 12.052 11.2081 12.0518 11.3735C12.054 11.7185 11.9193 12.0502 11.6773 12.2961C11.4352 12.5419 11.1055 12.6817 10.7605 12.6847ZM7.65317 1.29214L7.50016 1.91387C7.26318 2.81662 6.83198 3.65676 6.23668 4.37561C5.75622 5.00757 5.0742 5.45633 4.3037 5.64748V11.0558L5.92872 11.6052C6.32379 11.7393 6.7382 11.8076 7.1554 11.8073H10.7612C10.8772 11.8073 10.9884 11.7612 11.0705 11.6792C11.1525 11.5972 11.1986 11.4859 11.1986 11.3699C11.1986 11.2539 11.1525 11.1427 11.0705 11.0606C10.9884 10.9786 10.8772 10.9325 10.7612 10.9325C10.6453 10.9325 10.5341 10.8865 10.4521 10.8045C10.3701 10.7225 10.3241 10.6114 10.3241 10.4954C10.3241 10.3795 10.3701 10.2683 10.4521 10.1864C10.5341 10.1044 10.6453 10.0583 10.7612 10.0583H11.6211C11.7371 10.0583 11.8482 10.0123 11.9302 9.93033C12.0122 9.84836 12.0582 9.73718 12.0582 9.62126C12.0582 9.50534 12.0122 9.39417 11.9302 9.3122C11.8482 9.23023 11.7371 9.18418 11.6211 9.18418H10.7605C10.6446 9.18418 10.5334 9.13813 10.4515 9.05616C10.3695 8.97419 10.3234 8.86302 10.3234 8.74709C10.3234 8.63117 10.3695 8.52 10.4515 8.43803C10.5334 8.35606 10.6446 8.31001 10.7605 8.31001H11.6211C11.7371 8.31001 11.8482 8.26396 11.9302 8.18199C12.0122 8.10002 12.0582 7.98885 12.0582 7.87293C12.0582 7.757 12.0122 7.64583 11.9302 7.56386C11.8482 7.48189 11.7371 7.43584 11.6211 7.43584H10.7605C10.6446 7.43584 10.5334 7.38979 10.4515 7.30782C10.3695 7.22585 10.3234 7.11468 10.3234 6.99876C10.3234 6.88284 10.3695 6.77166 10.4515 6.68969C10.5334 6.60773 10.6446 6.56168 10.7605 6.56168H11.6211C11.7371 6.56168 11.8482 6.51562 11.9302 6.43366C12.0122 6.35169 12.0582 6.24051 12.0582 6.12459C12.0582 6.00867 12.0122 5.8975 11.9302 5.81553C11.8482 5.73356 11.7371 5.68751 11.6211 5.68751H7.31745C7.20153 5.68751 7.09035 5.64146 7.00838 5.55949C6.92641 5.47752 6.88036 5.36635 6.88036 5.25042C6.88036 5.1345 6.92641 5.02333 7.00838 4.94136C7.09035 4.85939 7.20153 4.81334 7.31745 4.81334H8.19936C8.45521 4.10201 8.59431 3.35398 8.61127 2.59822V2.1663C8.61195 2.05218 8.59014 1.93905 8.5471 1.83336C8.50406 1.72766 8.44062 1.63148 8.3604 1.55031C8.28018 1.46913 8.18477 1.40456 8.07959 1.36026C7.97442 1.31596 7.86155 1.29281 7.74743 1.29214H7.65317ZM0.860617 4.81786V11.8106H3.01311C3.12812 11.8095 3.23804 11.7629 3.31876 11.681C3.39948 11.5991 3.44443 11.4885 3.44374 11.3735V5.25494C3.44443 5.13993 3.39948 5.02933 3.31876 4.9474C3.23804 4.86547 3.12812 4.81888 3.01311 4.81786H0.860617Z' fill='%2333A7B2'/%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    width: 13px;
                    height: 13px;
                    margin-right: 5px;
                }
            }

            .like {
                margin-right: 24px;
            }

            .dislike {
                .image {
                    transform: rotate(180deg);
                    position: relative;
                    top: 2px;
                }
            }
        }
    }
`;

export const CommentsArea = styled.div`
    .avatar {
        border-radius: 100%;
        width: 55px;
        min-width: 55px;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${props => props.theme.colors.bitterLemon};
        color: white;
        margin-right: 16px;

        @media ${props => props.theme.device.mobile} {
            margin-right: 10px;
            width: 45px;
            min-width: 45px;
            height: 45px;
        }

        .initials {
            @media ${props => props.theme.device.mobile} {
                font-size: 20px;
            }
        }
    }

    .my-comment {
        display: flex;
        margin-bottom: 18px;
        align-items: center;
        opacity: 1;
        transition: opacity 0.2s;

        &.unvisible {
            opacity: 0;
            transition: opacity 0.2s;
        }

        .input-wrapper {
            display: flex;
            align-items: center;
            width: 100%;

            input { 
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                border-radius: 30px;
                border-color: transparent;
                height: 46px;
                padding: 0 20px;
            }

            div {
                margin-bottom: 0;
                height: 46px;
                width: 100%;
            }

            .share-comment-wrapper {
                width: 33px;
                min-width: 33px;
                height: 33px;
                border-radius: 100%;
                background-color: ${props => props.theme.colors.moonstone};
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 13px;
                cursor: pointer;

                .share-comment {
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'%3E%3Cpath d='M12.7531 9.11112L12.7531 9.11111C12.7727 9.10908 12.7901 9.09654 12.805 9.08374C12.8105 9.07899 12.8161 9.07387 12.8215 9.06891C12.8235 9.06707 12.8255 9.06524 12.8274 9.06347C12.8348 9.05678 12.8419 9.0506 12.8489 9.04547L12.8624 9.03561L12.848 9.02711C12.841 9.02295 12.8338 9.0179 12.8264 9.01243C12.8191 9.00707 12.8113 9.00116 12.8036 8.99584C12.7884 8.98532 12.7711 8.97531 12.7522 8.97411L12.7522 8.97411C12.3094 8.94732 11.8663 8.92256 11.4233 8.89781C11.2843 8.89004 11.1452 8.88227 11.0062 8.87443L9.33152 8.78059L7.65685 8.68675L5.97118 8.59257L4.28551 8.4984C4.12388 8.48934 3.96224 8.47999 3.80059 8.47064C3.3693 8.44568 2.93791 8.42073 2.50621 8.40136C2.45028 8.39886 2.41469 8.38884 2.39036 8.36804C2.36606 8.34726 2.35101 8.314 2.34049 8.25996C2.19373 7.50491 2.04324 6.75067 1.89275 5.99642C1.85326 5.79848 1.81376 5.60054 1.77434 5.40258C1.49095 3.97762 1.20719 2.55266 0.923405 1.12754C0.89519 0.985849 0.866975 0.844159 0.83876 0.702468L0.827973 0.704616L0.838764 0.702485C0.834424 0.680507 0.830914 0.658568 0.826511 0.631048C0.82494 0.621231 0.823255 0.610704 0.821379 0.599211L18.148 8.97055C12.2839 11.9231 6.44603 14.8624 0.586077 17.8126C0.604403 17.7299 0.622132 17.6497 0.639516 17.5709C0.674501 17.4125 0.708089 17.2604 0.742329 17.1085C0.848383 16.6374 0.954473 16.1664 1.06056 15.6954C1.47943 13.8356 1.89829 11.9759 2.3149 10.1158C2.32683 10.0625 2.3406 10.0269 2.36467 10.0031C2.38846 9.97968 2.42404 9.96621 2.48365 9.96179C3.07147 9.91892 3.65878 9.86936 4.246 9.8198C4.4185 9.80524 4.591 9.79068 4.7635 9.77629C5.10083 9.74814 5.43816 9.71986 5.77548 9.69157C6.28197 9.64909 6.78847 9.60662 7.29497 9.56462C7.66716 9.53374 8.03941 9.50325 8.41166 9.47275L8.41294 9.47265C8.78562 9.44212 9.15831 9.41159 9.53094 9.38067C10.0009 9.34163 10.4709 9.30224 10.9408 9.26286C11.3184 9.23122 11.6959 9.19958 12.0734 9.16812C12.1474 9.16194 12.2216 9.15615 12.2957 9.15035C12.4482 9.13844 12.6008 9.12652 12.7531 9.11112Z' fill='white' stroke='black' stroke-width='0.0220032'/%3E%3C/svg%3E");
                    width: 17px;
                    height: 17px;
                    background-repeat: no-repeat;
                }
            }
        }
    }

    .my-comments {
        margin-bottom: 20px;
    }

    .others, .my-comments, .last-comments {
        .comment-item {
            margin-bottom: 18px;

            .name {
                margin-bottom: 2px;
                padding-left: calc(55px + 28px);

                @media ${props => props.theme.device.mobile} {
                    padding-left: calc(45px + 28px);
                }
            }

            .comment-container {
                display: flex;
                align-items: center;

                @media ${props => props.theme.device.tablet} {
                    padding-right: 46px;
                }

                @media ${props => props.theme.device.mobile} {
                    padding-right: 0;
                }

                .comment-wrapper {
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    border-radius: 30px;
                    min-height: 46px;
                    height: 100%;
                    padding: 12px 12px 12px 20px;
                    background-color: white;
                    width: 100%;
                    max-width: calc(100% - 235px);
                    display: flex;
                    align-items: center;

                    @media ${props => props.theme.device.desktop} {
                        max-width: calc(100% - 180px);
                    }

                    @media ${props => props.theme.device.laptop} {
                        max-width: calc(100% - 120px);
                    }

                    @media ${props => props.theme.device.tablet} {
                        max-width: 100%;
                    }

                    .edit-comment-wrapper {
                        input {
                            padding: 0px;
                            height: 22px !important;
                            border: none;

                            &:focus {
                                box-shadow: none;
                            }
                        }

                        div {
                            height: 22px !important;
                            margin-bottom: 0;
                            height: 46px;
                            width: 100%;

                            span {
                                left: 0;
                            }
                        }
                    }
                }

                .edit-comment {
                    padding-left: 10px;

                    .edit-comment-label {
                        color: ${props => props.theme.colors.moonstone};
                        cursor: pointer;
                        &.d-none{
                        display:none!important;
                        }
                    }
                }

                .share-comment-wrapper {
                    width: 33px;
                    min-width: 33px;
                    height: 33px;
                    border-radius: 100%;
                    background-color: ${props => props.theme.colors.moonstone};
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-left: 13px;
                    cursor: pointer;

                    .share-comment {
                        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'%3E%3Cpath d='M12.7531 9.11112L12.7531 9.11111C12.7727 9.10908 12.7901 9.09654 12.805 9.08374C12.8105 9.07899 12.8161 9.07387 12.8215 9.06891C12.8235 9.06707 12.8255 9.06524 12.8274 9.06347C12.8348 9.05678 12.8419 9.0506 12.8489 9.04547L12.8624 9.03561L12.848 9.02711C12.841 9.02295 12.8338 9.0179 12.8264 9.01243C12.8191 9.00707 12.8113 9.00116 12.8036 8.99584C12.7884 8.98532 12.7711 8.97531 12.7522 8.97411L12.7522 8.97411C12.3094 8.94732 11.8663 8.92256 11.4233 8.89781C11.2843 8.89004 11.1452 8.88227 11.0062 8.87443L9.33152 8.78059L7.65685 8.68675L5.97118 8.59257L4.28551 8.4984C4.12388 8.48934 3.96224 8.47999 3.80059 8.47064C3.3693 8.44568 2.93791 8.42073 2.50621 8.40136C2.45028 8.39886 2.41469 8.38884 2.39036 8.36804C2.36606 8.34726 2.35101 8.314 2.34049 8.25996C2.19373 7.50491 2.04324 6.75067 1.89275 5.99642C1.85326 5.79848 1.81376 5.60054 1.77434 5.40258C1.49095 3.97762 1.20719 2.55266 0.923405 1.12754C0.89519 0.985849 0.866975 0.844159 0.83876 0.702468L0.827973 0.704616L0.838764 0.702485C0.834424 0.680507 0.830914 0.658568 0.826511 0.631048C0.82494 0.621231 0.823255 0.610704 0.821379 0.599211L18.148 8.97055C12.2839 11.9231 6.44603 14.8624 0.586077 17.8126C0.604403 17.7299 0.622132 17.6497 0.639516 17.5709C0.674501 17.4125 0.708089 17.2604 0.742329 17.1085C0.848383 16.6374 0.954473 16.1664 1.06056 15.6954C1.47943 13.8356 1.89829 11.9759 2.3149 10.1158C2.32683 10.0625 2.3406 10.0269 2.36467 10.0031C2.38846 9.97968 2.42404 9.96621 2.48365 9.96179C3.07147 9.91892 3.65878 9.86936 4.246 9.8198C4.4185 9.80524 4.591 9.79068 4.7635 9.77629C5.10083 9.74814 5.43816 9.71986 5.77548 9.69157C6.28197 9.64909 6.78847 9.60662 7.29497 9.56462C7.66716 9.53374 8.03941 9.50325 8.41166 9.47275L8.41294 9.47265C8.78562 9.44212 9.15831 9.41159 9.53094 9.38067C10.0009 9.34163 10.4709 9.30224 10.9408 9.26286C11.3184 9.23122 11.6959 9.19958 12.0734 9.16812C12.1474 9.16194 12.2216 9.15615 12.2957 9.15035C12.4482 9.13844 12.6008 9.12652 12.7531 9.11112Z' fill='white' stroke='black' stroke-width='0.0220032'/%3E%3C/svg%3E");
                        width: 17px;
                        height: 17px;
                        background-repeat: no-repeat;
                    }
                }
            }

            .comments-actions {
                display: flex;
                margin-top: 10px;
                padding-left: calc(55px + 28px);

                @media ${props => props.theme.device.mobile} {
                    padding-left: calc(45px + 28px);
                }
                
                .like, .comment {
                    margin-right: 20px;
                    cursor: pointer;
                    &.d-none{
                    display: none!important;
                    }
                }
            }
        }

        .view-more-container {
            display: flex;
            justify-content: flex-end;
            max-width: calc(100% - 163px );

            @media ${props => props.theme.device.desktop} {
                max-width: calc(100% - 109px);
            }

            @media ${props => props.theme.device.laptop} {
                max-width: calc(100% - 49px);
            }

            @media ${props => props.theme.device.tablet} {
                max-width: 100%;
                padding-right: 46px;
            }

            .view-more {
                cursor: pointer;
            }
        }
    }
`;

export const HtmlWrapper = styled.div`
  width: 100%;
  min-height: min-content;

  & h5 {
    font-size: 20px;
  }

  & ul {
    margin-top: 23px;
  }

  & li {
    position: relative;
    padding-left: 30px;
    margin-bottom: 5px;
  }

  & li::after {
    content: ${checkRounded};
    font-family: 's4b' !important ;
    font-size: 20px;
    height: 20px;
    color: ${props => props.theme.colors.primary.base};
    position: absolute;
    top: -1px;
    left: 0;
  }

  ${props =>
    props.withEllipsis &&
    css`
      & p:after {
        content: ' [...]'};
      }
    `}
`;
